var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smb-toolbar',{attrs:{"inline":_vm.inline,"items":_vm.toolbarOptions,"color":_vm.color,"icon-color":_vm.iconColor}})}
var staticRenderFns = []

export { render, staticRenderFns }